<template>
    <div class="modal fade show">
        <div class="modal-dialog modal-middle" v-if="task && logs">
            <div class="modal-content">
                <div class="modal-header my-modal-header">
                    <div class="row">
                        <div class="col-10">
                            <h5 class="mt-0 font-size-12 text-primary">{{ task.name }}</h5>
                            <p class="card-title-desc">Histórico do card após 11/07/2025.</p>
                        </div>
                        <div class="col-2">
                            <button type="button" class="btn-close float-end" @click="closeModalLog()"></button>
                        </div>
                    </div>
                </div>
                <div class="modal-body my-modal-body">
                    <div class="tab-content">
                        <div class="tab-pane active">
                            <div class="row">
                                <div class="col-12 mt-3">
                                    <table class="table table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <td width="20%">Data</td>
                                                <td width="30%">Usuário</td>
                                                <td width="50%">Ação</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-12 div-scroller">
                                    <table class="table table-bordered table-striped">
                                        <tbody>
                                            <tr v-for="log in logs" v-bind:key="log.id">
                                                <td width="20%">{{ log.created_at }}</td>
                                                <td width="30%">{{ log.user.email }}</td>
                                                <td width="50%">{{ log.action }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { status, meses, formatos } from '../../../data/data-static.js'
//import AppInputDate from "@/components/AppInputDate/AppInputDate.vue";
import { mapActions } from "vuex";
export default {
    props: {
        task_id: {
            type: Number,
            default: 0
        },
        board_name: {
            type: String,
            default: null
        }
    },
    components: {
    },
    data() {
        return {
            task: [],
            logs: []
        }
    },
    mounted() {
        this.passiveLoad()
    },
    methods: {
        ...mapActions([
            "showMessage",
            "showLoader"
        ]),
        async passiveLoad() {
            try {
                this.showLoader(true);
                const response = await this.$AppCallApi("GET", `f-task-log/${this.task_id}`);
                if (response.status === 200) {
                    const d = response.data.data;
                    this.task = d.task;
                    this.logs = d.logs;
                    console.log('load logs', JSON.stringify(d))
                }
            } catch (error) {
                console.log("error", error);
            } finally {
                this.showLoader(false);
            }
        },
        closeModalLog() {
            this.$emit("closeModalLog");
        }

    }
}
</script>
<style scoped>
.div-scroller{
    height: 400px;
    overflow-y: auto;
}
.modal-middle {
    width: 920px;
    max-width: 920px;
}

.normal-label {
    position: relative;
    float: left;
    width: 100%;
    top: 0px;
}

.normal-label input,
.normal-label label {
    position: relative;
    float: left;
    top: 0px;
    margin-right: 10px;
}

.normal-label label {
    padding: 0px;
}

.normal-label.active {
    cursor: pointer;
}

.normal-label.active::before {
    position: absolute;
    float: left;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    content: "";
    z-index: 6;
}

.normal-label.disabled {
    opacity: .7;
    cursor: not-allowed;
}

span.fake-input-checkbox {
    width: 14px;
    height: 14px;
    background: #f1f1f1;
    position: relative;
    float: left;
    border-radius: 3px;
    border: 1px solid #ccc;
    margin-right: 10px;
}

.nav-link.btn {
    border-radius: 0px;
    background: transparent;
    color: #000;
}

.nav-link.btn.active {

    color: #000;
    background: #FFF;
}

.nav>.nav-item:first-child>.nav-link.btn {
    border-top-left-radius: 8px;
}

.nav>.nav-item:last-child>.nav-link.btn {
    border-top-right-radius: 8px;
}

ul.list-users {
    max-height: 250px;
    overflow-x: auto;
    border-top: 1px solid #ddd;
    border-radius: 4px;
}

ul.list-users,
ul.list-users li {
    margin: 0px;
    padding: 0px;
    list-style: none;
}

ul.list-users li {
    display: flex;
    justify-content: space-between;
    border: 1px solid #ddd;
    border-top: none;
}

ul.list-users li>a {
    margin-right: 10px;
    cursor: pointer;
}

.remove-btn {
    padding: 0px;
    font-size: 14px;
    line-height: 14px;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    margin-right: 0px;
    text-align: center;
}

.modal.show {
    display: block;
    background: rgba(0, 102, 255, 0.5);
}

.modal-content {
    box-shadow: 0 0.75rem 1.5rem rgba(255, 255, 255, 0.3);
    background: #f1f2f4;
    border-radius: 0px !important;
}

.tab-content {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
}

.my-modal-header {
    display: block;
}

.my-modal-header,
.modal-body {
    padding: 2rem;
    border: none !important;
}

.my-modal-header {
    padding-bottom: 0rem;
}

.modal-body {
    padding-top: 0rem;
}

.my-modal-header h5 {
    display: block;
}

.btn-close {
    margin-top: -5px;
}

.btn-fixed-right {
    position: fixed;
    float: left;
    right: -200px;
    width: 150px;

}
</style>